 import { Brand } from "../types/brand"; 
import { createApiStore } from "./genericStore";
 
export const useBrandStore = createApiStore<Brand>("/brand");
